import styled from 'styled-components';

import ConfigurableModal from '~organisms/ConfigurableModal';

export const Container = styled(ConfigurableModal)(({ theme }) => ({
  '& .ant-modal-content': {
    padding: '30rem',
  },

  '& .ant-modal-footer': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '10rem',
    marginBlockStart: '25rem',

    '& button': {
      fontSize: theme.typography.size20,
    },
  },

  '& .modal-content': {
    maxWidth: '450rem',
    fontSize: theme.typography.size16,
    letterSpacing: 0,
    fontFamily: theme.typography.family.arial,
    lineHeight: '20rem',
    marginBlockStart: '26rem',
  },
}));
